import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { TabsType } from '@/v2/types'
import { CardType } from '@/v2/types/cards'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/how-ship-and-storage-works.jpg'),
    alt: 'how ship and storage works og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'how ship and storage works search image',
    width: 92,
    height: 92
  }
]

export const heroSectionContent = {
  title: 'How Ship & Storage <span>Works</span>',
  description:
    'We make shipping and storage easy. Just pack your items, measure them, and choose your shipping or storage option. From secure storage to global delivery, we handle every step so you can relax.',
  image: {
    url: '/images/v2/pages/main-pages/how-ship-and-storage-works/hero-image.png',
    alt: 'affordable college storage solutions page'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Store to Save' }
}

export const tabs: TabsType[] = [
  {
    id: 1,
    title: 'How Ship to Storage Works',
    image: {
      src: '/images/v2/pages/main-pages/how-ship-and-storage-works/tab1.svg',
      alt: 'affordable college storage solutions page'
    }
  },
  {
    id: 2,
    title: 'How Shipping Only Works',
    image: {
      src: '/images/v2/pages/main-pages/how-ship-and-storage-works/tab2.svg',
      alt: 'affordable college storage solutions page'
    }
  }
]

export const tabContent1: CardType[] = [
  {
    id: 1,
    title: 'Prepare Your Items',
    description:
      "Getting ready for a move, a new job, school, or a big event? We’ve got you covered! Simply pack your essentials, whether it's luggage, boxes, sports gear, or equipment.",
    image: {
      src: '/images/v2/pages/main-pages/how-ship-and-storage-works/prepare-your-items.svg',
      alt: 'Prepare Your Items'
    }
  },
  {
    id: 2,
    title: 'Measure Your Luggage/Box',
    description:
      'Measure the length, width, and height of each item to ensure accurate pricing and a smooth shipping or storage process with ShipAndStorage.',
    image: {
      src: '/images/v2/pages/main-pages/how-ship-and-storage-works/measure-your-luggage-box.png',
      alt: 'Measure Your Luggage/Box'
    }
  },
  {
    id: 3,
    title: 'Select Storage and Location',
    description:
      'Start by providing your current location and zip code. This helps us identify the closest shipping and storage facilities to serve you better.',
    image: {
      src: '/images/v2/pages/main-pages/how-ship-and-storage-works/select-storage-and-location.png',
      alt: 'Select Storage and Location'
    }
  },
  {
    id: 4,
    title: 'Storage Location and Shipping Date',
    description:
      'Check the “Shipping to Storage” option, select a convenient storage location, and choose your preferred shipping date to align with your schedule.',
    image: {
      src: '/images/v2/pages/main-pages/how-ship-and-storage-works/storage-location-and-shipping-date.png',
      alt: 'Storage Location and Shipping Date'
    }
  },
  {
    id: 5,
    title: 'Provide Luggage Size and Weight',
    description:
      'Enter the exact size and weight of each luggage piece to avoid incorrect pricing and ensure smooth handling during shipment.',
    image: {
      src: '/images/v2/pages/main-pages/how-ship-and-storage-works/provide-luggage-size-and-weight.png',
      alt: 'Provide Luggage Size and Weight'
    }
  },
  {
    id: 6,
    title: 'Select Your Shipping Method',
    description:
      'Pick a shipping method that fits your timeline. Enjoy free storage for up to six months if you select a round-trip service.',
    image: {
      src: '/images/v2/pages/main-pages/how-ship-and-storage-works/select-your-shipping-method.svg',
      alt: 'Select Your Shipping Method'
    }
  },
  {
    id: 7,
    title: 'Complete and Submit Your Order',
    description:
      'Review your details, confirm your order, and submit. You’ll receive a confirmation email with further instructions.',
    image: {
      src: '/images/v2/pages/main-pages/how-ship-and-storage-works/complete-and-submit-your-order.svg',
      alt: 'Complete and Submit Your Order'
    }
  },
  {
    id: 8,
    title: 'Receive Shipping Labels',
    description: 'We’ll email you the necessary shipping labels for your luggage. Print and attach them as instructed.',
    image: {
      src: '/images/v2/pages/main-pages/how-ship-and-storage-works/receive-shipping-labels.png',
      alt: 'Receive Shipping Labels'
    }
  },
  {
    id: 9,
    title: 'Pack and Label Your Luggage',
    description:
      'Carefully pack your items according to our guidelines. Securely attach the provided labels to each luggage or box.',
    image: {
      src: '/images/v2/pages/main-pages/how-ship-and-storage-works/pack-and-label-your-luggage.png',
      alt: 'Pack and Label Your Luggage'
    }
  },

  {
    id: 10,
    title: 'Pickup or Drop-off',
    description:
      'Choose between scheduling a pick-up from your location or dropping off at over 25,000 locations worldwide for added flexibility.',
    image: {
      src: '/images/v2/pages/main-pages/how-ship-and-storage-works/pickup-or-drop-off.svg',
      alt: 'Pickup or Drop-off'
    }
  },
  {
    id: 11,
    title: 'Secure Storage Notification',
    description:
      'ShipAndStorage safely delivers items within the USA and to over 220 countries, with the option to hold shipments at a local carrier for pick-up.',
    image: {
      src: '/images/v2/pages/main-pages/how-ship-and-storage-works/secure-storage-notification.svg',
      alt: 'Secure Storage Notification'
    }
  },
  {
    id: 12,
    title: 'Safe Storage Assurance',
    description:
      'Your luggage and boxes are securely stored in our monitored units with 24/7 security, kept safe and in excellent condition for whenever you need them.',
    image: {
      src: '/images/v2/pages/main-pages/how-ship-and-storage-works/safe-storage-assurance.svg',
      alt: 'Safe Storage Assurance'
    }
  }
]

export const tabContent2: CardType[] = [
  {
    id: 1,
    title: 'Prepare Your Items',
    description:
      'Planning a move, new job, school, or event? We’re here to help! Pack your essentials—luggage, boxes, or sports equipment—and leave the rest to us.',
    image: {
      src: '/images/v2/pages/main-pages/how-ship-and-storage-works/prepare-your-items2.svg',
      alt: 'Prepare Your Items'
    }
  },
  {
    id: 2,
    title: 'Measure Your Luggage/Box',
    description:
      'Accurately measure the length, width, and height of each item. This ensures precise pricing and smooth handling during the shipping or storage process with ShipAndStorage.',
    image: {
      src: '/images/v2/pages/main-pages/how-ship-and-storage-works/measure-your-luggage-box2.png',
      alt: 'Measure Your Luggage/Box'
    }
  },
  {
    id: 3,
    title: 'Select Storage and Location',
    description:
      'Start by entering your current location and zip code. This helps us identify the nearest storage and shipping options available for you.',
    image: {
      src: '/images/v2/pages/main-pages/how-ship-and-storage-works/select-storage-and-location2.svg',
      alt: 'Select Storage and Location'
    }
  },
  {
    id: 4,
    title: 'Choose Destination and Shipping Date',
    description:
      'Check the box labeled “Shipping to Storage” and select a storage location along with your preferred shipping date. This sets up your order for storage and shipment.',
    image: {
      src: '/images/v2/pages/main-pages/how-ship-and-storage-works/choose-destination-and-shipping-date.svg',
      alt: 'Choose Destination and Shipping Date'
    }
  },
  {
    id: 5,
    title: 'Provide Luggage Size and Weight',
    description:
      'Accurately select the size and weight of your luggage to avoid any overcharges. Ensuring correct details helps us process your shipment smoothly.',
    image: {
      src: '/images/v2/pages/main-pages/how-ship-and-storage-works/provide-luggage-size-and-weight2.svg',
      alt: 'Provide Luggage Size and Weight'
    }
  },
  {
    id: 6,
    title: 'Select Your Shipping Method',
    description:
      'Choose the shipping method that best suits your needs. Remember, we offer free storage for up to 6 months on round-trip orders, adding great value to your service.',
    image: {
      src: '/images/v2/pages/main-pages/how-ship-and-storage-works/select-your-shipping-method2.svg',
      alt: 'Select Your Shipping Method'
    }
  },
  {
    id: 7,
    title: 'Complete and Submit Your Order',
    description:
      'Follow these steps and submit your order. Once completed, you’ll receive a confirmation and can move on to the next steps in the process.',
    image: {
      src: '/images/v2/pages/main-pages/how-ship-and-storage-works/complete-and-submit-your-order2.svg',
      alt: 'Complete and Submit Your Order'
    }
  },
  {
    id: 8,
    title: 'Receive Shipping Labels by Email or Mail',
    description: 'ShipAndStorage will process your order quickly & send the shipping labels to you via email.',
    image: {
      src: '/images/v2/pages/main-pages/how-ship-and-storage-works/receive-shipping-labels-by-email-or-mail.png',
      alt: 'Receive Shipping Labels by Email or Mail'
    }
  },
  {
    id: 9,
    title: 'Pack Luggage and Stick Labels',
    description: "Follow ShipAndStorage's instructions: pack and lock luggage correctly, stick the labels on properly.",
    image: {
      src: '/images/v2/pages/main-pages/how-ship-and-storage-works/pack-luggage-and-stick-labels.png',
      alt: 'Pack Luggage and Stick Labels'
    }
  },

  {
    id: 10,
    title: 'We Pick up or You Drop off',
    description: 'We can pick up service from your location or you can drop-off at 25,000+ locations worldwide.',
    image: {
      src: '/images/v2/pages/main-pages/how-ship-and-storage-works/we-pick-up-or-you-drop-off.svg',
      alt: 'We Pick up or You Drop off'
    }
  },
  {
    id: 11,
    title: 'We Deliver Luggage to Your Door',
    description: 'ShipAndStorage will deliver your items anywhere in the USA and to over 220 countries.',
    image: {
      src: '/images/v2/pages/main-pages/how-ship-and-storage-works/we-deliver-luggage-to-your-door.svg',
      alt: 'We Deliver Luggage to Your Door'
    }
  },
  {
    id: 12,
    title: 'Satisfied Customer',
    description: 'Enjoy the joy of hassle-free delivery as your luggage or boxes arrive safely at your doorstep.',
    image: {
      src: '/images/v2/pages/main-pages/how-ship-and-storage-works/satisfied-customer.svg',
      alt: 'Satisfied Customer'
    }
  }
]

export const twoCardsBannerContent = {
  title: 'How to Get Back Your Stored Items',

  cards: [
    {
      id: 1,
      title: 'Order Shipping from Storage',
      description:
        'Have your items shipped directly to your doorstep without visiting our storage facility. Simply place your order through our online system. We’ll securely package and ship your belongings to ensure safe transit. ',
      image: {
        src: '/images/v2/pages/main-pages/how-ship-and-storage-works/order-shipping-from-storage.svg',
        alt: 'Order Shipping from Storage'
      }
    },

    {
      id: 2,
      title: 'Self-Pickup',
      description:
        'If you prefer to collect your items in person, you’re welcome to visit our storage facility at your convenience. Our friendly staff will assist you in retrieving your belongings quickly and efficiently. ',
      image: {
        src: '/images/v2/pages/main-pages/how-ship-and-storage-works/self-pickup.svg',
        alt: 'Self-Pickup'
      }
    }
  ]
}
